import { DefaultYourFinanceResponse } from '../yourFinance/yourFinanceTypes';
import { BorrowingPowerState, DefaultBorrowingPowerData } from './borrowingPowerTypes';

// eslint-disable-next-line import/prefer-default-export
export const initialStateBorrowingPower: BorrowingPowerState = {
    data: DefaultBorrowingPowerData,
    financeData: DefaultYourFinanceResponse,
};
